import { STREAM_MESSAGES_CONFIG } from "@/configs/Settings";
import { RTM_CONFIGS } from "@/configs/RTM_SDK";

const state = {
   likeCountLocal: 0,
   trackingLikeLocal: 0,
   listChannelMessages: [],
   adminChannelMessages: [],
   listYourMessages: [],
   listLikedAnimations: [],
   listRenderAnimations: [],
   currentIndexRender: -1,
   intervalUpdateRenderId: null,
   listUserJoined: [],
   streamDetail: {},
   eventDetail: {},
   streamStatistic: {
      view_count: 1,
      like_count: 0,
      slug: 0,
      enable_chat: true
   },
   isShowStreamProducts: false,
   streamEnded: false
};

const getters = {
   streamEnded(state) {
      return state.streamEnded;
   },
   getAllLikeCount(state) {
      return state.streamStatistic.like_count + state.likeCountLocal;
   },
   streamDetail(state) {
      return state.streamDetail;
   },
   eventDetail(state) {
      return state.eventDetail;
   },
   listChannelMessages(state) {
      return state.listChannelMessages;
   },
   listYourMessages(state) {
      return state.listYourMessages;
   },
   listLikedAnimations(state) {
      return state.listLikedAnimations;
   },
   listRenderAnimations(state) {
      return state.listRenderAnimations;
   },
   listUserJoined(state) {
      return state.listUserJoined;
   },
   streamStatistic(state) {
      return state.streamStatistic;
   },
   isShowStreamProducts(state) {
      return state.isShowStreamProducts;
   },
   trackingLikeLocal(state) {
      return state.trackingLikeLocal;
   },
   adminChannelMessages(state) {
      return state.adminChannelMessages;
   }
};

const mutations = {
   UPDATE_STREAM_ENDED(state, isEnd) {
      state.streamEnded = isEnd;
   },
   INCREASE_LIKE_COUNT_TOTAL(state, count) {
      state.streamStatistic.like_count += count;
   },
   INCREASE_LIKE_COUNT_LOCAL(state, count) {
      state.likeCountLocal += count;
   },
   INCREASE_TRACKING_LIKE_LOCAL(state, count) {
      state.trackingLikeLocal += count;
   },
   UPDATE_LIKE_COUNT_TOTAL(state, count) {
      state.streamStatistic.like_count = count;
   },
   UPDATE_LIKE_COUNT_LOCAL(state, count) {
      state.likeCountLocal = count;
   },
   UPDATE_TRACKING_LIKE_LOCAL(state, count) {
      state.trackingLikeLocal = count;
   },
   UPDATE_STREAM_DETAIL(state, streamDetail) {
      state.streamDetail = streamDetail;
   },
   UPDATE_EVENT_DETAIL(state, eventDetail) {
      state.eventDetail = eventDetail;
   },
   UPDATE_AND_LIMIT_LIST_CHANNEL_MESSAGES(state, listChannelMessages) {
      state.listChannelMessages = [...state.listChannelMessages, ...listChannelMessages];
      let diff = state.listChannelMessages.length - STREAM_MESSAGES_CONFIG.MAXIMUM_MESSAGES;
      if (diff > 0) {
         state.listChannelMessages.splice(0, diff);
      }
   },
   UPDATE_LIST_CHANNEL_MESSAGES(state, listChannelMessages) {
      state.listChannelMessages = listChannelMessages;
   },
   ADD_NEW_CHANNEL_MESSAGES(state, newMessage) {
      state.listChannelMessages.push(newMessage);
      if (state.listChannelMessages.length > STREAM_MESSAGES_CONFIG.MAXIMUM_MESSAGES) {
         state.listChannelMessages.shift();
      }
   },
   UPDATE_LIST_YOUR_MESSAGES(state, listYourMessages) {
      state.listYourMessages = listYourMessages;
   },
   REMOVE_NUMBER_MESSAGES_FROM_START_OF_LIST_YOUR_MESSAGES(state, number) {
      let listMessages = state.listYourMessages.splice(0, 0);
      state.listYourMessages = listMessages.splice(0, number);
   },
   ADD_NEW_YOUR_MESSAGES(state, newMessage) {
      state.listYourMessages.push(newMessage);
   },

   ADD_NEW_ADMIN_MESSAGES(state, newAdminMessage) {
      state.adminChannelMessages.push(newAdminMessage);
   },

   UPDATE_LIST_LIKED_ANIMATIONS(state, listLikedAnimations) {
      state.listLikedAnimations = listLikedAnimations;
      if (!state.listLikedAnimations.length && state.intervalUpdateRenderId) {
         clearInterval(state.intervalUpdateRenderId);
         state.intervalUpdateRenderId = null;
      }
   },

   ADD_NEW_LIKED_ANIMATION(state, likedAnimation) {
      if (state.listLikedAnimations.length < RTM_CONFIGS.MAXIMUM_RECEIVED_LIKES) {
         state.listLikedAnimations.push(likedAnimation);
      }

      if (!state.intervalUpdateRenderId) {
         state.intervalUpdateRenderId = setInterval(() => {
            if (state.listLikedAnimations[state.currentIndexRender + 1]) {
               state.currentIndexRender++;
               state.listRenderAnimations.push(state.listLikedAnimations[state.currentIndexRender]);
            }
         }, RTM_CONFIGS.DELAY_ANIMATION_LIKE);
      }
   },

   REMOVE_FIRST_LIKED_ANIMATION(state) {
      state.listLikedAnimations.splice(0, 1);
      state.listRenderAnimations.splice(0, 1);
      state.currentIndexRender--;
      if (!state.listLikedAnimations.length && state.intervalUpdateRenderId) {
         clearInterval(state.intervalUpdateRenderId);
         state.intervalUpdateRenderId = null;
      }
   },

   REQUEST_NEW_ANIMATION(state) {
      state.listRenderAnimations = state.listLikedAnimations.splice(0, 1);
   },

   UPDATE_LIST_USER_JOINED(state, newUser) {
      state.listUserJoined.push(newUser);
   },

   UPDATE_STREAM_STATISTIC(state, streamStatistic) {
      state.streamStatistic = Object.assign(state.streamStatistic, streamStatistic);
   }
};

const actions = {
   updateStreamEnded({ commit }, isEnd) {
      commit("UPDATE_STREAM_ENDED", isEnd);
   },
   increaseLikeCountTotal({ commit }, count) {
      commit("INCREASE_LIKE_COUNT_TOTAL", count);
   },
   increaseLikeCountLocal({ commit }, count) {
      commit("INCREASE_LIKE_COUNT_LOCAL", count);
   },
   increaseTrackingLikeLocal({ commit }, count) {
      commit("INCREASE_TRACKING_LIKE_LOCAL", count);
   },
   updateLikeCountLocal({ commit }, count) {
      commit("UPDATE_LIKE_COUNT_LOCAL", count);
   },
   updateLikeCountTotal({ commit }, count) {
      commit("UPDATE_LIKE_COUNT_TOTAL", count);
   },
   updateTrackingLikeLocal({ commit }, count) {
      commit("UPDATE_TRACKING_LIKE_LOCAL", count);
   },
   updateStreamDetail: ({ commit }, streamDetail) => {
      commit("UPDATE_STREAM_DETAIL", streamDetail);
   },
   updateAndLimitListChannelMessages: ({ commit }, listChannelMessages) => {
      commit("UPDATE_AND_LIMIT_LIST_CHANNEL_MESSAGES", listChannelMessages);
   },
   updateListChannelMessages: ({ commit }, listChannelMessages) => {
      commit("UPDATE_LIST_CHANNEL_MESSAGES", listChannelMessages);
   },
   addNewChannelMessages: ({ commit }, newMessage) => {
      commit("ADD_NEW_CHANNEL_MESSAGES", newMessage);
   },
   updateListYourMessages: ({ commit }, listYourMessages) => {
      commit("UPDATE_LIST_YOUR_MESSAGES", listYourMessages);
   },
   removeNumberMessagesFromStartOfListYourMessages: ({ commit }, number) => {
      commit("REMOVE_NUMBER_MESSAGES_FROM_START_OF_LIST_YOUR_MESSAGES", number);
   },
   addNewYourMessages: ({ commit, rootState }, newMessage) => {
      let message = {
         // format message
         MessageType: parseInt(newMessage.MessageType),
         GuestId: newMessage.GuestId,
         UserId: newMessage.UserId,
         DisplayName: newMessage.DisplayName,
         Timestamp: newMessage.Timestamp,
         Message: newMessage.Message,
         Channel: rootState.rtm.currentChannel
      };
      commit("ADD_NEW_YOUR_MESSAGES", message);
   },

   addNewAdminMessages: ({ commit }, newAdminMessage) => {
      commit("ADD_NEW_ADMIN_MESSAGES", newAdminMessage);
   },
   updateListLikedAnimations: ({ commit }, listLikedAnimations) => {
      commit("UPDATE_LIST_LIKED_ANIMATIONS", listLikedAnimations);
   },

   addNewLikedAnimation: ({ commit }, likedAnimation) => {
      commit("ADD_NEW_LIKED_ANIMATION", likedAnimation);
   },

   removeFirstLikeAnimation: ({ commit }) => {
      commit("REMOVE_FIRST_LIKED_ANIMATION");
   },
   updateListUserJoined: ({ commit }, newUser) => {
      commit("UPDATE_LIST_USER_JOINED", newUser);
   },

   updateStreamStatistic: ({ commit }, streamStatistic) => {
      commit("UPDATE_STREAM_STATISTIC", streamStatistic);
   }
};

export default {
   state,
   getters,
   mutations,
   actions
};
